import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/admin/auth/AdminAuth.css";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const savedEmail = localStorage.getItem("adminEmail");
    const savedPassword = localStorage.getItem("adminPassword");
    const savedData = localStorage.getItem("adminData");

    if (savedEmail && savedData) {
      navigate("/admin/dashboard");
    }
  }, [navigate]);


  const handlelogin = (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(
        `${baseUrl}/admin/auth/admin-login`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          localStorage.setItem("adminEmail", email);
          localStorage.setItem("adminPassword", password);
          localStorage.setItem("adminData", JSON.stringify(response.data.admin));
          navigate("/admin/dashboard");
        } else {
          alert(response.data.message || "Login failed");
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Server error");
        setLoading(false);
      });
  };

  return (
    <div className="esl-login-page">
      <div className="esl-login-card">

        {/* ===== Brand ===== */}
        <div className="esl-login-brand">
          <div className="esl-login-logo">S</div>
          <span className="esl-login-brand-name">Estetica Skin&Laser</span>
        </div>

        {/* ===== Heading ===== */}
        <h2 className="esl-login-heading">Admin sign in</h2>
        <p className="esl-login-subtext">Enter your credentials to access the dashboard.</p>

        {/* ===== Form ===== */}
        <form>

          {/* Email */}
          <div className="esl-form-group">
            <label className="esl-form-label">Email</label>
            <input
              className="esl-form-control"
              type="email"

              value={email}
              onChange={(e) => {
                setEmail(e.target.value);

              }}
              required
            />
            {/* {emailError && (
              <p style={{ color: "#e53e3e", fontSize: "12px", marginTop: "4px" }}>
                {emailError}
              </p>
            )} */}
          </div>

          {/* Password */}
          <div className="esl-form-group">
            <label className="esl-form-label">Password</label>
            <div style={{ position: "relative" }}>
              <input
                className="esl-form-control"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                style={{ paddingRight: "60px" }}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "14px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "12px",
                  color: "#8A94A6",
                  fontWeight: "500",
                  padding: "0",
                }}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
            {/* {passwordError && (
              <p style={{ color: "#e53e3e", fontSize: "12px", marginTop: "4px" }}>
                {passwordError}
              </p>
            )} */}
          </div>

          <button
            className="esl-btn-signin"
            onClick={handlelogin}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>

        </form>
      </div>
    </div>
  );
};

export default AdminLogin;